import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Button from "@mui/material/Button";

const truncateWords = (text, wordLimit = 15) => {
  if (!text) return text;
  const words = text.trim().split(/\s+/);
  return words.length > wordLimit ? `${words.slice(0, wordLimit).join(" ")}...` : text;
};

export default function faqTableData({ faqList = [], onEdit, onDelete }) {
  return {
    columns: [
      { Header: "Question", accessor: "question", width: "40%", align: "left" },
      { Header: "Answer", accessor: "answer", width: "40%", align: "left" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: faqList.map((faq) => ({
      question: (
        <MDTypography variant="button" fontWeight="medium">
          {faq?.question}
        </MDTypography>
      ),
      answer: (
        <MDTypography variant="caption" color="text" fontWeight="medium" title={faq?.answer}>
          {truncateWords(faq?.answer)}
        </MDTypography>
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <Button size="small" onClick={() => onEdit(faq)}>
            Edit
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => onDelete(faq?.id)}
            sx={{
              backgroundColor: "#d32f2f",
              color: "#fff",
              "&:hover": { backgroundColor: "#9a0007" },
            }}
          >
            Delete
          </Button>
        </MDBox>
      ),
    })),
  };
}
